// src/config.js

const isProduction = process.env.NODE_ENV === 'production';

// Base URL for backend API
export const API_BASE_URL = isProduction
  ? 'https://bsparksoftwaretechnologies.com/backend/api'
  : 'http://localhost/Bspark_Website/backend/api';

// Define endpoints
export const API = {
  BASE: API_BASE_URL,
  COURSES: `${API_BASE_URL}/api.php/api/courses`,   // GET
  ENROLL: `${API_BASE_URL}/api.php/api/enroll`,     // POST
  FLAT_REGISTER :`${API_BASE_URL}/register.php/api/register`,  

};
